var collectionVue = new Vue({
    el: '.collection.vue',
    data: {
        filters: {
            'colour': [],
            'size': [],
            'type': [],
            'shape': []
        },
        products: [],
        defaultProducts: [],
        sortValue: 'relevance',                
        section: '',
        defaultSizes: [
            { 
                key: 'Microfine',
                value: 'Microfine - 0.1mm - 1/256" - 0.004"',
                range: true
            },
            { 
                key: 'Ultrafine',
                value: 'Ultrafine - 0.2mm - 1/128" - 0.008"',
                range: true
            },
            { 
                key: 'Fine',
                value: 'Fine - 0.4mm - 1/64" - 0.015"',
                range: true 
            },
            { 
                key: 'Chunky',
                value: 'Chunky - 0.6mm - 1/40" - 0.025"',
                range: true 
            },
            { 
                key: 'Extra Chunky',
                value: 'Extra Chunky - 1mm - 1/24" - 0.040"',
                range: true 
            },
            { 
                key: 'Super Chunky',
                value: 'Super Chunky - 3mm - 1/8" - 0.125"',
                range: true 
            },
            { 
                key: '2.5L / 84floz',
                value: '2.5L / 84floz',
                class: 'two-half-liter-84floz'
            },
            { 
                key: '1L / 34floz',
                value: '1L / 34floz',
                class: 'one-liter-34floz'
            },
            { 
                key: 'A5 Peel & Stick Sample',
                value: 'A5 Peel & Stick Sample',
                class: 'a5-peel-stick-sample'
            }
        ],
        isShopByColour: false,
        sections: [                 
            'Ready Mix Grout',
            'Ready Mixed Glitter Grout',                      
            'Glitter Shaker',                    
            'Glitter Shaker Mixed',
            'Multi Size Glitter Shaker',                      
            'Ultra Sparkle Glitter',
            'Ultra Sparkle Glitter Multi',
            'Mixed Ultra Sparkle Glitter',
            'Shaped Ultra Sparkle Glitter',
            'Craft Glitter',
            'Craft Glitter Multi',
            'Shaped Craft Glitter',
            'Polyurethane & Epoxy Glitter',
            'Mixed Polyurethane & Epoxy Glitter',
            'Craft Glitter Shaker',
            'Mega Craft Shaker',
            'Eco Friendly Glitter',
            'Bio Ultra Sparkle Glitter',
            'Eco Craft Glitter',                                            
            'Glitter Paint Additive',
            'Glitter Grout Additive',
            'Auto Flake',
            'Glitter Box Sets',
            'Interior Paint',
            'Exterior Paint',
            'Chalk Paint',
            'Chalk Based Furniture Paint',
            'Clear Lacquers',
            'Blockers',
            'Bamboo Painting Kits',
            'Bamboo Paint Roller Frames',
            'Paint Roller Sleeves',
            'Bio Paint Roller Trays',
            'Painters Tapes',
            'Recyclable Dust Sheets',
            'Bamboo Paint Stirrers',
            'Beeswax Polish',          
            'Bamboo Paint Brushes',
            'Chalk & Wax Paint Brushes',
            'Buffing Pads',
            'Kitchen & Bathroom Sealant',
            'Construction Sealant',
            'Glitter Sealant',                      
            'Powder Pigment',
            'Natural Dye',                  
            'Grout Dye',                      
            'Epoxy Dye',
            'Cement Dye',
            'Mica Dye',
            'Automotive Powder Pigment'
        ],
        sectionsSpecialOrders: [
            {
                filter: 'Multi Purpose Glitter',
                sections: [
                    'Ultra Sparkle Glitter'
                ]
            }
        ],
        shopByTypeItems: [         
            'Glitter Shakers',
            'Multi Purpose Glitter',
            'Multi Purpose Glitters',
            'Craft Glitters',
            'Crafting Glitters',
            'Epoxy Glitters',          
            'Eco Friendly Glitters',
            'Paint Glitters',
            'Grout Glitters',          
            'Automotive Glitters',
            'Glitter Box Sets',
            'Buffing Pads',
            'Interior Acrylic Paints',
            'Exterior Acrylic Paints',
            'Chalk Paints',
            'Furniture Paints',
            'Blockers',
            'Bamboo Painting Kits',
            'Bamboo Paint Roller Frames',
            'Paint Roller Sleeves',
            'Bio Paint Roller Trays',
            'Paint Brushes',
            'Painters Tapes',
            'Recyclable Dust Sheets',
            'Bamboo Paint Stirrers',
            'Clear Lacquers',
            'Beeswax Polish',
            'Ready Mixed Grouts',
            'Ready Mixed Glitter Grouts',
            'Multi Purpose Powders',
            'DIY Powders',
            'Cosmetic Powders',
            'Automotive Powders',
            'Kitchen Sealants',
            'Bathroom Sealants',
            'Construction Sealants',
            'Glitter Sealants'
        ],
        reviews: {},
        allReviews: [],
        rawReviews: [],
        page: 1,
        perPage: 5,
        selectedReview: null,
        photosUrl: 'https://cdn.stamped.io/uploads/photos',
        videosUrl: 'https://cdn.stamped.io/uploads/videos',
        apifyPhotosUrl: 'https://alt.hemway.com/uploads',
        apifyVideosUrl: 'https://alt.hemway.com/uploads',
        productType: '',
        toLoadProducts: false,
        currentProductsPage: 1,
        totalPages: 0,                
        searchResultsLimit: 125,
        fetchingReviews: []
    },
    mounted() {
        const _this = this;
        if ( ! window.products ) { return; }
        $( '.collection.main.default' ).remove();
        $( '.collection.vue' ).removeClass( 'hidden' );       
        this.defaultProducts = JSON.parse( JSON.stringify( window.products ) );
        this.$set( this.filters, 'size', JSON.parse( JSON.stringify( window.filterSize ) ) );
        if ( 'grout-colour' in this.filterKeys ) {
            this.$set( this.filters, 'grout-colour', [] );
        }
        setTimeout(() => {
            _this.filterProducts();
        }, 1);
        $(document).on( 'change', '.sort', function() {
            _this.products = _this.sortProducts( _this.products, $(this).val() );
            const $mirror = $( '.sort-mirror' );
            $mirror.text( $( 'option:selected', this ).text() );
            let width = $mirror.outerWidth() + 83;
            $(this).css({'width': width + 'px'});
        });
        $( '.shop.collection .filters .content .links .content ul.three li.one' ).click(function() {
            for ( let key in _this.filterKeys ) {
                const term = _this.filterKeys[key];
            }            
        });                
        const totalResults = window.totalResults;        
        if ( totalResults > this.searchResultsLimit ) {
            let div = totalResults / this.searchResultsLimit;
            let totalPages = div % 1 > 0 ? ( parseInt( div ) + 1 ) : div;
            this.toLoadProducts = true;
            this.totalPages = totalPages;
            this.currentProductsPage += 1;
        } else {
            if ( location.href.includes( 'order=1' ) ) {
                this.reorderCollectionProducts();
            }
        }
        setTimeout(() => {            
            _this.parseReviews();
        }, 1);
    },
    watch: {
        currentProductsPage( val, oldval ) {
            if ( val == this.totalPages ) {
                if ( location.href.includes( 'order=1' ) ) {
                    this.reorderCollectionProducts();
                }
                if (  window.showReviews ) {
                    this.parseReviews();
                }
            }
        },
        toLoadProducts( val, oldval ) {
            const _this = this;
            if ( ! val ) {
                return false;
            }
            this.toLoadProducts = false;
            fetch('/search.api?q=gid:' + window.collectionHandle + '&page=' + this.currentProductsPage + "&limit=" + this.searchResultsLimit)
            .then((response) => response.json())
            .then((data) => {
                data.products.forEach((item, i) => {
                    var title_tags = item.tags.filter(tag => tag.includes( 'Title_' ));
                    if ( title_tags.length ) {
                        item.title = title_tags[0].replace( 'Title_', '' );
                    }
                });
                let products = JSON.parse( JSON.stringify( _this.defaultProducts ) ).concat( data.products );
                _this.$set( _this, 'defaultProducts', products );
                _this.$set( _this, 'products', JSON.parse( JSON.stringify( _this.defaultProducts ) ) );      
                setTimeout(() => {
                    _this.filterProducts();
                    if ( this.currentProductsPage < this.totalPages ) {
                        this.currentProductsPage += 1;
                        this.toLoadProducts = true;
                    } else {
                        _this.toLoadProducts = false;
                    }
                }, 1);
            });
        }
    },
    computed: {
        utils() {
            return Utils ? Utils : {};
        },  
        defaultColours() {
            if ( window.defaultColours.length > 0 ) {
                return window.defaultColours[0].colours || {};
            }
            return {};
        },   
        filterKeys() {
            let filters = {
                'colour': {
                    'title': 'Colour',
                    'items': []
                },
                'size': {
                    'title': 'Size',
                    'items': []
                },
                'type': {
                    'title': 'Type',
                    'items': []
                },
                'shape': {
                    'title': 'Shape',
                    'items': []
                }              
            };
            if ( window.hasFiltersColour ) {                
                let colours = [];                      
                this.defaultProducts.forEach((product) => {
                    if ( product.options.some(option => [ 'Colour', 'Glitter Colour' ].includes(option)) ) {                        
                        const tags = product.tags.filter(tag => tag.includes( 'Tone_' ) );
                        tags.forEach(tag => {
                            const colour = tag.replace( 'Tone_', '' );                        
                            if ( ! colours.includes( colour ) ) {
                                colours.push(colour);
                            }
                        });
                    }
                });
                for ( const colour in this.defaultColours ) {
                    if ( colours.includes( colour ) ) {
                        filters[ 'colour' ].items.push( colour );
                    }
                }                
            }
            if ( window.hasFiltersSize || window.filterSize.length ) {
                let sizes     = [];
                let size_tags = [];
                this.defaultProducts.forEach((product) => {
                    let proceed = true;
                    for (let i = 0; i < product.tags.length; i++) {
                        let tag = product.tags[i];
                        if ( tag.includes( 'Size_' ) && ! size_tags.includes( tag ) ) {
                            size_tags.push( tag );
                            proceed = false;
                        }
                    }
                    if ( proceed ) {
                        product.variants.forEach(variant => {
                            if ( variant.options.length > 1 && ! sizes.includes( variant.options[1] ) ) {
                                sizes.push( variant.options[1] );
                            }
                        });
                    }
                });    
                sizes = this.defaultSizes.filter(size => sizes.findIndex(item => item.includes( size.key) ) !== -1);                      
                let new_sizes = [];
                size_tags.forEach(tag => {
                    tag = tag.replace( 'Size_', '' );
                    if ( sizes.findIndex(size => size.key.includes(tag)) == -1 ) {
                        new_sizes.push({
                            key: tag,
                            range: false,
                            value: tag
                        });
                    }
                });
                filters[ 'size' ].items = sizes.concat( new_sizes );
            }
            if ( window.hasFiltersType ) {
                if ( window.isFilterTypeTag ) {
                    let types = [];
                    this.defaultProducts.filter((product) => {
                        for (i = 0; i < product.tags.length; i++) {
                            if ( product.tags[i].includes( 'Type_' ) ) {
                                return true;
                            }
                        }
                        return false;
                    }).forEach((product) => {
                        const key = product.tags.filter((tag) => tag.includes( 'Type_' ))[0].split( 'Type_' )[1];
                        if ( ! types.includes( key ) ) {
                            types.push( key );
                        }
                    });
                    filters[ 'type' ].items = types;
                } else {
                    filters[ 'type' ].items = Object.keys( this.groupedProducts.default );
                }
                let types = [];
                this.shopByTypeItems.forEach(section => {
                    if ( filters[ 'type' ].items.includes( section )  ) {
                        types.push( section );
                    }
                });
                filters[ 'type' ].items.forEach(item => {
                    if ( ! types.includes( item ) ) {
                        types.push( item );
                    }
                });
                filters[ 'type' ].items = types;
            }
            if ( window.hasFiltersShape ) {
                let shapes     = [];
                let shape_tags = [];
                this.defaultProducts.forEach((product) => {
                    product.tags.forEach(tag => {
                        if ( tag.includes( 'Shapes_' ) && ! shape_tags.includes( tag ) ) {
                            shape_tags.push( tag );
                        }
                    });
                });
                shape_tags.forEach(tag => {
                    tag = tag.replace( 'Shapes_', '' );
                    shapes.push({
                        key: tag,
                        range: false,
                        value: tag
                    });
                });
                filters[ 'shape' ].items = shapes;
            }
            if ( [ 'grout', 'ready-mixed-glitter-grout', 'test' ].includes( window.collectionHandle ) ) {
                filters[ 'grout-colour' ] = {
                    'title': 'Grout Colour',
                    'items': []
                };
                let colours = [];
                this.defaultProducts.forEach((product) => {
                    product.variants.forEach(variant => {
                        const colour = variant.options[0];
                        if ( ! colours.includes( colour ) ) {
                            colours.push( colour );
                        }
                    });
                });
                for ( const colour in this.defaultColours ) {
                    if ( this.defaultColours[colour].some(item => colours.includes(item))) {
                        filters[ 'grout-colour' ].items.push( colour );
                    }
                }
            }
            return filters;
        }, 
        groupedProducts() {
            let items = {
                'default': {},
                'featured': {}
            };
            const _this = this;
            let products = JSON.parse( JSON.stringify( this.products ) );
            if ( window.sectionsFeatured && this.filters.colour.length == 0 ) {
                products = products.filter((product) => {
                    for (i = 0; i < product.tags.length; i++) {
                        if ( product.tags[i] == 'Collection_Featured' || product.handle.includes( 'shaped' ) ) {
                            return true;
                        }
                    }
                    return false;
                });
            }
            const sectioned_products = products.filter((product) => {
                for (i = 0; i < product.tags.length; i++) {
                    if ( product.tags[i].includes( 'Collection_' ) && product.tags[i] !== 'Collection_Featured' ) {
                        return true;
                    }
                }
                return false;
            });
            if ( window.sectionsFeatured && this.filters.colour.length == 0 ) {
                products.filter(product => product.tags.includes( 'Collection_Featured' ) && ! sectioned_products.includes( product ))
                .forEach(product => {
                    if ( product.product_type in items.featured ) {
                        items.featured[ product.product_type ].items.push( product );
                    } else {
                        items.featured[ product.product_type ] = {
                            'items': [ product ],
                            'colours': true
                        };
                    }
                });
            }
            products.filter(product => ! sectioned_products.includes( product ))
            .forEach(product => {
                if ( product.product_type in items.default ) {
                    items.default[ product.product_type ].items.push( product );
                } else {
                    items.default[ product.product_type ] = {
                        'items': [ product ],
                        'colours': true
                    };
                }
            });
            sectioned_products.forEach((product) => {
                const key = product.tags.filter((tag) => tag.includes( 'Collection_' ) && tag !== 'Collection_Featured')[0].split( 'Collection_' )[1];
                if ( key in items.default ) {
                    items.default[key].items.push( product );
                } else {
                    items.default[key] = {
                        'items': [ product ],
                        'colours': false,
                        'mixed': true
                    };
                }
            });
            if ( window.sectionsFeatured ) {
                sectioned_products.forEach((product) => {
                    const key = product.tags.filter((tag) => tag.includes( 'Collection_' ) && tag !== 'Collection_Featured')[0].split( 'Collection_' )[1];
                    if ( product.tags.includes( 'Collection_Featured' ) ) {
                        if ( key in items.featured ) {
                            items.featured[key].items.push( product );
                        } else {
                            items.featured[key] = {
                                'items': [ product ],
                                'colours': false,
                                'mixed': true
                            };
                        }
                    }
                });
            }
            let results = {
                default: {},
                featured: {}
            };
            for ( let type in items ) {
                this.sections.forEach(section => {
                    if ( section in items[type] ) {
                        results[type][section] = items[type][section];
                    }
                });
                for ( let section in items[type] ) {
                    if ( ! ( section in results[type] ) ) {
                        results[type][section] = items[type][section];
                    }
                }
            }
            if ( window.tagsSize > 0 ) {
                let results2 = {
                    default: {},
                    featured: {}
                };
                for ( let type in results ) {
                    if ( Object.keys( results[type] ).length > 0 ) {
                        results2[type] = {
                            '': {
                                items: []
                            }
                        };
                        for ( let section in results[type] ) {
                            results2[type][''].items = results2[type][''].items.concat( results[type][section].items );   
                        }                              
                    }              
                }
                return results2;
            }
            if ( this.filters.type.length ) {
                for ( let i = 0; i < this.sectionsSpecialOrders.length; i++ ) {
                    const item = this.sectionsSpecialOrders[i];
                    if ( _this.filters.type.includes( item.filter ) ) {
                        let _results = {
                            default: {},
                            featured: {}
                        };
                        for ( let type in results ) {
                            item.sections.forEach(section => {
                                if ( section in results[type] ) {
                                    _results[type][section] = results[type][section];
                                }
                            });
                            
                            for ( let section in results[type] ) {
                                if ( ! ( section in _results[type] ) ) {
                                    _results[type][section] = results[type][section];
                                }
                            }
                        }
                        results = _results;
                        break;
                    }    
                }
            }
            if ( 'relevance' == this.sortValue ) {
                return results;
            }
            if ( [ 'price-low', 'price-high' ].includes( this.sortValue ) ) {
                for ( let type in results ) {
                    let sortedCategories = null;
                    if ( 'price-low' == this.sortValue ) {
                        sortedCategories = Object.entries(results[type]).sort((a, b) => {
                            const minPriceA = Math.min(...a[1].items.map(item => parseFloat(item.price.raw)));
                            const minPriceB = Math.min(...b[1].items.map(item => parseFloat(item.price.raw)));
                            return minPriceA - minPriceB;
                        });
                    } else {
                        sortedCategories = Object.entries(results[type]).sort((a, b) => {
                            const minPriceA = Math.max(...a[1].items.map(item => parseFloat(item.price.raw)));
                            const minPriceB = Math.max(...b[1].items.map(item => parseFloat(item.price.raw)));
                            return minPriceB - minPriceA;
                        });
                    }
                    results[type] = Object.fromEntries( sortedCategories );
                }
            } else if ( [ 'popular', 'newest' ].includes( this.sortValue ) ) {
                const keyword = 'Highlight_' + ( 'newest' == this.sortValue ? 'New In' : ( this.sortValue.charAt(0).toUpperCase() + this.sortValue.slice(1) ) );
                for ( let type in results ) {
                    let items = {};
                    for (let key in results[type]) {
                        let category = results[type][key];
                        if ( category.items.findIndex(item => item.tags.includes(keyword)) > -1 ) {
                            items[key] = category;
                        }
                    }
                    for (let key in results[type]) {
                        let category = results[type][key];
                        if ( ! ( key in items ) ) {
                            items[key] = category;
                        }
                    }
                    results[type] = items;
                }
            }
            return results;
        },
        availableSizes() {
            return this.filterKeys.size.items;
        },
        hasActivefilters() {
            for ( let key in this.filters ) {
                if ( 'size' != key && this.filters[key].length ) {
                    return true;
                }
            }
            if ( this.filters.size.length ) {
                if ( ! window.hasFiltersSize && window.filterSize.length ) {
                    return this.filters.size.filter(item => ! window.filterSize.includes(item)).length > 0;
                }
                return true;
            }
            if ( this.filters.shape && this.filters.shape.length ) {
                return true;
            }
            return false;
        },
        activeFilters() {
            const _this = this;
            let filters = JSON.parse( JSON.stringify( this.filters ) );
            if ( filters.size.length && window.hasFiltersSize ) {
                filters.size = this.filterKeys.size.items.filter(item => filters.size.findIndex(size => size == item.key) !== -1);
            }
            if ( ! window.hasFiltersSize ) {
                    filters.size = [];
            }
            if ( filters.shape.length && window.hasFiltersShape ) {
                filters.shape = this.filterKeys.shape.items.filter(item => filters.shape.includes(item.key));
            }
            return filters;
        },
        hasFilterKeys() {
            for ( let key in this.filterKeys ) {
                if ( this.filterKeys[key].items.length ) {
                    return true;
                }
            }
            return false;
        },
        pages() {
            if ( ! window.showReviews ) {
                return [];
            }
            const total = this.rawReviews.length;
            const page  = this.page;
            let pages = Array.from( {length: ( total >= 5 ? 5 : total )}, (_, i) => i + 1 );
            if ( total <= 5 || page < 4  ) {
                return pages;
            }
            if ( ( page - 2 ) > 0 ) {
                pages = [ page - 2, page - 1, page ];
            }
            if ( ( page + 2 ) <= total ) {
                pages.push( page + 1 );
                pages.push( page + 2 );
            } else if ( ( page + 1 ) <= total ) {
                pages.push( page + 1 );
                pages.unshift( pages[0] - 1 );
            } else {
                pages.unshift( pages[0] - 1 );
                pages.unshift( pages[0] - 1 );
            }
            return pages;
        },
        media() {
            if ( ! window.showReviews ) {
                return [];
            }
            let reviews = this.rawReviews;
            let items   = [];
            if ( reviews.length == 0 ) {
                return items;
            }
            for ( let i = 0; i < reviews.length; i++ ) {
                let review = reviews[i];
                if ( ( review.imagesFileNamePublished.length > 0 || review.videosFileNamePublished.length > 0 ) && review.rating >= 4 ) {
                    items.push( review );
                    if ( items.length >= 10 ) {
                        break;
                    }
                }
            }
            return items;
        },
        summary() {
            if ( ! window.showReviews ) {
                return {};
            }
            return Object.keys(this.reviews || {}).length ? Object.values(this.reviews)[0] : {};
        },
        hasGroupReview() {
            return group => {
                const summary = this.getGroupReviewSummary(group);
                return summary && Object.keys(summary).length > 0 && parseFloat(summary.average) > 4;
            };
        }
    },
    methods: {
        getFilterClass(term, type) {
            if ( 'size' == type ) {
                let filters = this.filterKeys.size.items;
                const index = filters.findIndex(item => item.key == term);
                if ( index >= 0 ) {
                    term = 'class' in filters[index] ? filters[index].class : filters[index].key;  
                }                      
            }
            return this.utils.htmlEntities( term.toLowerCase().replace(/[\/\s&]+/g, '-') );
        },
        setFilterSelection(term, type) {
            this.filters[type].includes(term) ? this.filters[type] = this.filters[type].filter(item => item !== term) : this.filters[type].push(term);
            // $(document).find( '.filters.two .attribute.' + type + ' .term.' + this.getFilterClass( term, type ) ).toggleClass( 'active' );
            this.filterProducts();
        },
        filterProducts() {
            const isShapedCollectionPage = [
                'shaped-glitter'
            ].includes(window.collectionHandle);
            const _this = this;
            let products = JSON.parse( JSON.stringify( this.defaultProducts ) ); 
            console.log( 'Colour Filters:', this.filters.colour );
            console.log( 'Before Filter:', products.length);
            if ( window.isFilterTypeTag && this.filters.type.length ) {
                let filters = this.filters.type;
                products = products.filter((product) => {
                    for (i = 0; i < filters.length; i++) {
                        if ( product.tags.includes( 'Type_' + filters[i] ) ) {
                            return true;
                        }
                    }
                    return false;
                });
            }
            if ( this.filters.size.length ) {
                let filters = this.filters.size;  
                let tmp_products = products.filter((product) => {
                    for (i = 0; i < filters.length; i++) {
                        let size = _this.filterKeys.size.items.filter(item => item.key == filters[i])[0].key;
                        if ( product.tags.includes( 'Size_' + size ) ) {
                            product.size = size;
                            return true;
                        }
                    }
                    return false;
                });
                products.forEach((product) => {
                    if ( ! tmp_products.includes( product ) ) {                                
                        for(let i = 0; i < filters.length; i++) {
                            let size_index = _this.filterKeys.size.items.findIndex(item => item.key == filters[i]);
                            const size = _this.filterKeys.size.items[size_index].key;
                            const index = product.variants.findIndex(variant => variant.options.length > 1 && variant.options[1].includes( size ));
                            if ( index !== -1 ) {
                                let _product = JSON.parse( JSON.stringify( product ) );
                                let variant = _product.variants[ index ];
                                if ( ! ( 'hover_image' in variant ) && 'hover_image' in _product.variants[0] ) {
                                    variant.hover_image = _product.variants[0].hover_image;
                                }
                                _product.id = variant.id;
                                _product.price = variant.price;
                                _product.url = _product.url + '?variant=' + variant.id;
                                _product.size = _this.filterKeys.size.items[size_index].key;
                                _product.variants = [ variant ];
                                tmp_products.push( _product );
                            }
                        }
                    }
                }); 
                products = tmp_products;
            }
            if ( this.filters.shape.length ) {
                let filters = this.filters.shape;  
                let tmp_products = products.filter((product) => {
                    for (i = 0; i < filters.length; i++) {
                        let shape = filters[i];
                        if ( product.tags.includes( 'Shapes_' + shape ) ) {
                            return true;
                        }
                    }
                    return false;
                });
                products = tmp_products;
            }
            let filters = this.filters.colour;
            if ( filters.length ) {
                const isShapedCollectionPage = window.location.pathname.includes( '/collections/shaped-glitter' );
                if ( isShapedCollectionPage ) {
                    const colourProducts = [];
                    products.forEach( product => {
                        const colourOptionIndexes = product.options.reduce( ( indexes, option, idx ) => {
                            if ( [ 'Colour', 'Glitter Colour' ].includes( option ) ) {
                                indexes.push( idx );
                            }
                            return indexes;
                        }, [] );
                        if ( colourOptionIndexes.length ) {
                            const matchingVariants = product.variants.filter( variant => {
                                return colourOptionIndexes.some( idx => {
                                    return filters.some( tone => {
                                        const colours = _this.defaultColours[ tone ] || [];
                                        return colours.includes( variant.options[ idx ] );
                                    });
                                });
                            });
                            matchingVariants.forEach( variant => {
                                const _product = JSON.parse( JSON.stringify( product ) );
                                _product.id = variant.id;
                                _product.price = variant.price;
                                _product.url = _product.url + '?variant=' + variant.id;
                                _product.variants = [ variant ];
                                colourProducts.push( _product );
                            });
                        }
                    });
                    products = colourProducts;
                } else {
                    products = products.filter( product => {
                        if ( !product.options.some( option => [ 'Colour', 'Glitter Colour' ].includes( option ) ) ) {
                            return false;
                        }
                        return filters.some( filter => product.tags.includes( `Tone_${filter}` ) );
                    });
                }
            }
            const groutIdentifier = 'Grout Colour';
            if ( 'grout-colour' in this.filterKeys && this.filterKeys['grout-colour'].items.length ) {
                if ( this.filters['grout-colour'].length ) {
                    filters = this.filters['grout-colour'];
                    let groutProducts = [];
                    products = products.filter(product => product.options.includes( groutIdentifier ));
                    if ( products.length ) {
                        filters.forEach(key => { 
                            let colours = this.defaultColours[key];
                            products.forEach(product => { 
                                let index = product.options.findIndex(option => option == groutIdentifier);
                                let variants = product.variants.filter(variant => colours.includes( variant.options[index] ));
                                if ( variants.length ) {
                                    variants.forEach(variant => {
                                        let _product = JSON.parse( JSON.stringify( product ) );
                                        _product.id = variant.id;
                                        _product.price = variant.price;
                                        _product.url = _product.url + '?variant=' + variant.id;
                                        _product.variants = [ variant ];
                                        groutProducts.push( _product );
                                    });
                                }
                            });
                        });
                    }
                    products = groutProducts;
                } else {
                    let groutProducts = [];
                    const _products = products.filter(product => product.options.includes( groutIdentifier ));
                    _products.forEach(product => {
                        product.variants.forEach(variant => {
                            let _product = JSON.parse( JSON.stringify( product ) );
                            _product.id = variant.id;
                            _product.price = variant.price;
                            _product.url = _product.url + '?variant=' + variant.id;
                            _product.variants = [ variant ];
                            groutProducts.push( _product );
                        });
                    });
                    products = groutProducts.concat( products.filter(product => ! product.options.includes( groutIdentifier )));
                }
            }
            let shapedProducts = [];
            let otherProducts = [];
            products.forEach(product => {
                if ( this.isShapedCollection(product) ) {
                    product.variants.forEach(variant => {
                        let _product = JSON.parse(JSON.stringify(product));
                        _product.id = variant.id;
                        _product.price = variant.price;
                        _product.url = _product.url + '?variant=' + variant.id;
                        _product.variants = [ variant ];
                        shapedProducts.push(_product);
                    });
                } else {
                    otherProducts.push(product);
                }
            });
            products = shapedProducts.concat(otherProducts);
            this.products = this.sortProducts( products, this.sortValue );
        },
        sortProducts( products, order ) {
            switch(order) {
                case 'relevance':
                products = JSON.parse( JSON.stringify( this.defaultProductSort( products ) ) );
                break;
                case 'price-low':
                products.sort((a,b) => parseFloat( a.price.raw ) - parseFloat( b.price.raw ));
                break;
                case 'price-high':
                products.sort((a,b) => parseFloat( b.price.raw ) - parseFloat( a.price.raw ));
                break;
                default:
                let keyword = 'Highlight_' + ( 'newest' ? 'New In' : order.charAt(0).toUpperCase() + order.slice(1) );
                products.sort(function(a, b) {                          
                    let hasNewInA = a.tags.includes( keyword );
                    let hasNewInB = b.tags.includes( keyword );                          
                    if ( hasNewInA && ! hasNewInB ) {
                        return -1;
                    } else if (! hasNewInA && hasNewInB ) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                break;
            }
            return products;
        },
        getColourCount( product ) {                
            return parseInt( product.colour_count );
        },
        renderColourCount( product ) {
            const total = this.getColourCount( product );
            return total + ' ' + ( product.product_type.includes( 'Shaped' ) ? 'Shape' : 'Colour' ) + ( total == 1 ? '' : 's' );
        },
        hasColours( product ) {
            const keys = [ 'Colour', 'Grout Colour', 'Glitter Colour', 'Sealant Colour' ];
            return keys.some(option => keys.includes(option));
        },
        getProductColour( product ) {
            let variant = product.variants[0]; // variant-specific display
            let text    = '';
            if ( product.options.includes( 'Grout Colour' ) || product.options.includes( 'Glitter Colour' ) ) {
                if ( product.options.includes( 'Grout Colour' ) && product.options.includes( 'Glitter Colour' ) ) {
                    let groutIndex   = product.options.indexOf( 'Grout Colour' );
                    let glitterIndex = product.options.indexOf( 'Glitter Colour' );
                    let groutColour  = variant.options[ groutIndex ] || '';
                    let glitterColour = variant.options[ glitterIndex ] || '';
                    text = groutColour && glitterColour ? groutColour + ' & ' + glitterColour : groutColour || glitterColour;
                } else {
                    let key  = product.options.includes( 'Grout Colour' ) ? 'Grout Colour' : 'Glitter Colour';
                    let index = product.options.indexOf( key );
                    text = variant.options[ index ] || '';
                }
            } else if ( product.options.includes( 'Colour' ) ) {
                let index = product.options.indexOf( 'Colour' );
                text = variant.options[ index ] || '';
            } else if ( product.options.includes( 'Sealant Colour' ) ) {
                let index = product.options.indexOf( 'Sealant Colour' );
                text = variant.options[ index ] || '';
            }
            if ( 'size' in product ) {
                text += ' / ' + product.size;
            }
            return text;
        },
        getHighlights( product ) {
            let items = [];
            let tags = product.tags.filter(tag => tag.includes( 'Highlight' ));
            tags.forEach(tag => {
                items.push( tag.replace( 'Highlight_', '' ) );
            });
            return items;
        },
        shopByFilter(term, type) {  
            const _this = this;
            this.setFilterSelection(term, type);
            if ( this.filters[type].includes(term) ) {
                let anchor = 'collection';
                if ( $(window).width() <= 1350 ) {
                    switch (type) {
                        case 'type':
                            if ( this.filterKeys.colour.items.length ) {
                                anchor = 'colour';
                            } else if ( this.filterKeys.size.items.length && window.hasFiltersSize ) {
                                anchor = 'size';
                            }
                            break;      
                        case 'colour':
                            if ( this.filterKeys.size.items.length && window.hasFiltersSize ) {
                                anchor = 'size';
                            }
                            break;
                    }
                }
                setTimeout(() => {                              
                    $( 'html, body' ).animate({
                        scrollTop: $( '[name="' + anchor + '"]' ).offset().top - ( $(window).width() >= 1350 ? 82 : 0 )
                    }, 1375);
                }, 75);
            }
        },
        resetFilters(type = null) {
            const _this = this;
            if ( type ) {
                this.filters[type] = [];
                // $( '.filters.two .attribute.' + type + ' .term.active' ).removeClass( 'active' );
                if ( 'size' == type ) {
                    let products = JSON.parse( JSON.stringify( this.products ) );
                    products.forEach(product => {
                        delete product.size;
                    });
                    this.products = products;
                }
                if ( 'shape' == type ) {
                    this.filters[type] = [];
                }
            } else {
                this.filters = {
                    'colour': [],
                    'size': [],
                    'type': [],
                    'shape': []
                };
                if ( ! window.hasFiltersSize && window.filterSize.length ) {
                    this.$set( this.filters, 'size', JSON.parse( JSON.stringify( window.filterSize ) ) );
                    setTimeout(() => {
                        _this.filterProducts();
                    }, 1);
                } else {                      
                    this.products = JSON.parse( JSON.stringify( this.defaultProducts ) );
                }
                // $( '.filters.two .term.active' ).removeClass( 'active' ); 
            }
        },
        defaultProductSort( products ) {                  
            let results = [];
            this.defaultProducts.forEach(product => {
                let items = products.filter( item => item.product_id == product.id );
                results = results.concat( items );
            });
            return results;
        },
        getFeaturedImage( product ) {
            if ( ! product.variants.length ) {
                return '';
            }
            if ( product.variants[0].background_image ) {
                return product.variants[0].background_image;
            } else if ( product.variants.length > 3 ) {
                return product.variants[3].image;
            } else {
                return product.variants[0].image;
            }                   
        },
        async getReviews( productType ) {
            const _this = this;
            const productId = encodeURIComponent(productType);
            let url = `https://alt.hemway.com/api/index.php/review/summary?productId=${productId}`;
            
            const payload = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            this.fetchingReviews.push( productType );

            let ratings = await fetch( url, payload )
                .then( response => response.json() )
                .catch( error => {
                    console.error( 'Error:', error );
                    return [];
                }).finally(() => {
                    _this.fetchingReviews = _this.fetchingReviews.filter( item => item !== productType );
                });

                if ( window.showReviews ) {
                    this.populateAllReviews( productType );
                }
            
            return ratings;
        },
        async populateAllReviews( productType ) {
            const productId = encodeURIComponent(productType);
            const payload = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            
            let url = 'https://alt.hemway.com/api/index.php/review/list?productId=' + productId;
            let reviews = await fetch( url, payload )
                .then( response => response.json() )
                .then( data => {
                    data.results.forEach(item => {
                        item.imagesFileNamePublished = item.imagesFileNamePublished ? item.imagesFileNamePublished.split( ',' ) : [];
                        item.videosFileNamePublished = item.videosFileNamePublished ? item.videosFileNamePublished.split( ',' ) : [];
                        item.source = 'stamped';
                    });
                    return data;
                })
                .catch( error => {
                    console.error( 'Error:', error );
                    return [];
                });
            
            url = 'https://alt.hemway.com/apify/api/index.php/review/list?productId=' + productId;
            let reviews_amazon = await fetch( url, payload )
                .then( response => response.json() )
                .then( data => {
                    data.results.forEach(item => {
                        item.imagesFileNamePublished = item.imagesFileName ? JSON.parse( item.imagesFileName ) : [];
                        item.videosFileNamePublished = item.videosFileName ? JSON.parse( item.videosFileName ) : [];
                        item.source = 'apify';
                    });
                    return data;
                })
                .catch( error => {
                    console.error( 'Error:', error );
                    return [];
                });          
            let results = reviews.results.concat( reviews_amazon.results );                  
            if ( results.length ) {
                results = results.sort((a,b) => new Date( b.dateAdded ) - new Date( a.dateAdded ));   
                results = results.sort((a,b) => new Date( b.rating ) - new Date( a.rating )); 
                results = results.sort((a,b) => new Date( b.isFeatured ) - new Date( a.isFeatured ));
            }
            this.rawReviews = results;            
            this.allReviews = this.paginateReviews( results );
            setTimeout(() => {
                this.initReviewsSwiper();
            }, 1);
        },
        paginateReviews( reviews ) {
            let items = [[]];
            let totalPages = 0;
            totalPages = reviews.length / this.perPage;
            totalPages = reviews.length % this.perPage > 0 ? ( parseInt( totalPages ) + 1 ) : totalPages;
            let c = 1;
            reviews.forEach(review => {
                if ( c > this.perPage ) {
                    items.push([]);
                    c = 1;
                }
                items[ items.length - 1 ].push( review );
                c++;
            });
            return items;
        },
        parseReviews() {
            const _this = this;
            if ( ! window.showReviews ) {
                this.reviews = window.defaultReviews;
                this.products.forEach(product => {
                    const reviewTag = product.tags.find(tag => tag.startsWith('Reviews_'));
                    if ( reviewTag ) {
                        const productId = reviewTag.replace('Reviews_', '' );            
                        if ( productId in _this.reviews ) {
                            return false;
                        }
                        if ( _this.fetchingReviews.includes( productId ) ) {
                            return false;
                        }
                        Promise.resolve( _this.getReviews( productId ) )
                        .then((results) => {
                            _this.$set( _this.reviews, productId, results ); 
                        })
                        .catch( error => {
                            console.error( 'Error:', error );
                        }); 
                    }
                });
                return false;
            }
            let key = Object.keys( this.groupedProducts.featured ).length ? 'featured' : 'default';
            let first_section = Object.keys(this.groupedProducts[key])[0];
            let productType = first_section ? this.groupedProducts[key][ first_section ].items[0].product_type : null; 
            if ( productType && 'mixed' in _this.groupedProducts[key][ first_section ] ) {
                _this.groupedProducts[key][ first_section ].items.forEach(product => {
                    productType = product.product_type;
                    if ( ! ( productType in _this.reviews ) ) {    
                        _this.getReviewsByType( productType );
                    }
                });

                Object.keys(_this.groupedProducts[key]).forEach(section => {
                    if ( first_section != section ) {                                
                        if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                            _this.groupedProducts[key][ section ].items.forEach(product => {      
                                productType = product.product_type;
                                if ( ! ( productType in _this.reviews ) ) {    
                                    _this.getReviewsByType( productType );
                                }
                            });
                        } else {
                            productType = _this.groupedProducts[key][ section ].items[0].product_type;
                            if ( ! ( productType in _this.reviews ) ) {                     
                                _this.getReviewsByType( productType );
                            }
                        }
                    }
                });
                
                if ( 'featured' == key ) {
                    key = 'default';
                    Object.keys(_this.groupedProducts[key]).forEach(section => {
                        if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                            _this.groupedProducts[key][ section ].items.forEach(product => {      
                                productType = product.product_type;
                                if ( ! ( productType in _this.reviews ) ) {    
                                    _this.getReviewsByType( productType );
                                }
                            });
                        } else {
                            productType = _this.groupedProducts[key][section].items[0].product_type;
                            if ( ! ( productType in _this.reviews ) ) {                     
                                _this.getReviewsByType( productType );
                            }
                        }
                    });
                }
                
            } else {
                Promise.resolve( this.getReviews( productType ) )
                .then((results) => {
                    _this.$set( _this.reviews, productType, results );
                }).then(() => {                        
                    Object.keys(_this.groupedProducts[key]).forEach(section => {
                        if ( first_section != section ) {
                            if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                                _this.groupedProducts[key][ section ].items.forEach(product => {      
                                    productType = product.product_type;
                                    if ( ! ( productType in _this.reviews ) ) {    
                                        _this.getReviewsByType( productType );
                                    }
                                });
                            } else {
                                productType = _this.groupedProducts[key][section].items[0].product_type;
                                if ( ! ( productType in _this.reviews ) ) {                     
                                    _this.getReviewsByType( productType );
                                }
                            }
                        }
                    });
                    if ( 'featured' == key ) {
                        key = 'default';
                        Object.keys(_this.groupedProducts[key]).forEach(section => {
                            if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                                _this.groupedProducts[key][ section ].items.forEach(product => {      
                                    productType = product.product_type;
                                    if ( ! ( productType in _this.reviews ) ) {    
                                        _this.getReviewsByType( productType );
                                    }
                                });
                            } else {
                                productType = _this.groupedProducts[key][section].items[0].product_type;
                                if ( ! ( productType in _this.reviews ) ) {                     
                                    _this.getReviewsByType( productType );
                                }
                            }
                        });
                    }
                })
                .catch( error => {
                    console.error( 'Error:', error );
                });   
            }
        },
        getReviewsByType( productType ) {
            const _this = this;
            const product   = this.products.find(item => item.product_type == productType);
            const reviewTag = product.tags.find(tag => tag.startsWith('Reviews_'));
            const productId = reviewTag ? reviewTag.replace('Reviews_', '') : productType;
            
            if ( productId in _this.reviews ) {
                return;
            }
            if ( _this.fetchingReviews.includes( productId ) ) {
                return;
            }

            Promise.resolve( this.getReviews( productId ) )
                .then((results) => {
                    _this.$set( _this.reviews, productType, results ); 
                })
                .catch( error => {
                    console.error( 'Error:', error );
                }); 
        },
        getGroupReviewSummary(group, product = null) {
            product = ( product && ( 'mixed' in group ) ) ? product : group.items[0];
            const reviewTag = product.tags.find(tag => tag.startsWith('Reviews_'));
            const product_type = reviewTag ? reviewTag.replace('Reviews_', '') : product.product_type;
            return this.reviews[ product_type ] || {};
        },
        slugifiedString(str) {
            const decodedString = str.replace( /&#44;/g, ',' );
            const slugifiedString = decodedString
                .toLowerCase()
                .replace( /[^a-z0-9]+/g, '-' )
                .replace( /(^-|-$)/g, '' );
            return slugifiedString;
        },
        reorderCollectionProducts() {
            if ( window.sortOrder == 'manual' ) {
                let body = []; 
                let sections = Object.keys( this.groupedProducts.featured ).length ? this.groupedProducts.featured : this.groupedProducts.default;
                for (let key in sections) {                            
                    sections[key].items.forEach((product, i) => {
                        if ( body.findIndex(item => item.id == product.id) == -1 ) {
                            body.push({
                                "id": product.id,
                                "newPosition": body.length.toString()
                            });
                        }
                    });
                }                      
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", "Basic Og==");                  
                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify( body ),
                    redirect: "follow"
                };
                
                fetch("http://alt.hemway.com/api/index.php/shopify/collections/" + window.collectionId + "/reorder-products", requestOptions)
                    .then((response) => response.text())
                    .then((result) => console.log(result))
                    .catch((error) => console.error(error));
            }
        },               
        getRevieweeInitials( review ) {
            if ( ! review ) {
                return '';
            }
            let arr = review.author.split( ' ' );
            let str = arr[0].charAt(0) + '' + ( arr.length == 1 && arr[0].length > 1 ? arr[0].charAt(1) : arr[ arr.length - 1 ].charAt(0) );
            return str;
        },
        paginate( val ) {
            let page = this.page;
            switch (val) {
                case 'prev':
                    page--;
                    break;
                case 'next':
                    page++;
                    break;
                default:
                    page = val;
            }
            if ( ! ( page > this.reviews.length || page < 0 ) ) {
                this.page = page;
                setTimeout(() => {
                    $( 'html, body' ).animate({
                        scrollTop: $( '.reviews .anchor.two' ).offset().top
                    }, 1375);
                }, 1);
            }
        },
        buildStar2(star) {
            const average = parseFloat( Object.values( this.reviews )[0].average );
            let str = 'icons8-star';
            switch (star) {
                case 1:
                    if ( this.utils.inRange( average, 0.25, 0.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 0.75 ) {
                        str += '-2';
                    }
                    break;
                case 2:
                    if ( this.utils.inRange( average, 1.25, 1.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 1.75 ) {
                        str += '-2';
                    }
                    break;
                case 3:
                    if ( this.utils.inRange( average, 2.25, 2.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 2.75 ) {
                        str += '-2';
                    }
                    break;
                case 4:
                    if ( this.utils.inRange( average, 3.25, 3.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 3.75 ) {
                        str += '-2';
                    }
                    break;
                case 5:
                    if ( this.utils.inRange( average, 4.25, 4.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 4.75 ) {
                        str += '-2';
                    }
                    break;
            }
            return str;
        },
        showReviewModal( review ) {
            this.selectedReview = review;
            setTimeout(() => {
                $( '.reviews .modal' ).addClass( 'delay' );
                setTimeout(function() {
                    $( '.reviews .modal' ).addClass( 'active' );
                }, 100);
            }, 1);
        },
        hideReviewModal() {
            const _this = this;
            $( '.reviews .modal' ).removeClass( 'active' );
            setTimeout(function() {
                _this.selectedReview = null;
                $( '.reviews .modal' ).removeClass( 'delay' );
            }, 600);
        },
        initReviewsSwiper() {
            const swiperProductTwo = new Swiper( '.reviews .slider', {
                containerModifierClass: 'slide-',
                noSwipingClass: 'alt',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                speed: 750,
                spaceBetween: 12,
                navigation: {
                    disabledClass: 'disabled',
                    nextEl: '.reviews .slider .buttons .next',
                    prevEl: '.reviews .slider .buttons .previous',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                    },
                    600: {
                        slidesPerView: 3,
                    },
                    900: {
                        slidesPerView: 4,
                    }
                }
            });
        },
        getphotosUrl(source) {
            return 'apify' == source ? this.apifyPhotosUrl : this.photosUrl;
        },
        getvideosUrl(source) {
            return 'apify' == source ? this.apifyVideosUrl : this.videosUrl;
        },
        getFeaturedImageAltText( product ) {
            let text = '';
            if ( product.variants.length ) {                      
                if ( product.variants[0].background_image ) {
                    text = product.variants[0].background_image_alt_text;
                } else if ( product.variants.length > 3 ) {
                    text = product.variants[3].image_alt_text;
                } else {
                    text = product.variants[0].image_alt_text;
                }
            }
            if ( ! text ) {
                text = product.title;
            }
            return text;
        },
        getHoverImageAltText( product ) {
            let text = '';
            if ( product.variants[0].hover_image ) {
                text = product.variants[0].hover_image_alt_text;
            }
            if ( ! text ) {
                text = this.getFeaturedImageAltText( product );
            }
            return text;
        },
        isShapedCollection( product ) {
            const shapedTags = [
                'Collection_Shaped Ultra Sparkle Glitter',
                'Collection_Shaped Craft Glitter'
            ];
            return product.tags.some( tag => shapedTags.includes( tag ) );
        }
    }
});